import { render, staticRenderFns } from "./V2Layout.vue?vue&type=template&id=2159ea5f&"
import script from "./V2Layout.vue?vue&type=script&lang=js&"
export * from "./V2Layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports